export function mapFolder(folder, source) {
  const createdAt = folder.createdDate instanceof Date ? folder.createdDate.getTime() : undefined;
  return {
    id: folder.id ?? '',
    siteId: '',
    kind: 'folder',
    source,
    name: folder.displayName ?? '',
    parentId: folder.parentFolderId ?? null,
    createdAt,
    tags: []
  };
}
export function mapFolders(folders, source) {
  if (folders === void 0) {
    folders = [];
  }
  return folders.map(folder => mapFolder(folder, source));
}
//# sourceMappingURL=Folder.mappers.js.map